import React, { useEffect, useState } from 'react'
import { Close } from '@aok/icon-functional'
import { ContextHeadline } from '@aok/text-elements'
import { getHeadlineText } from '../../../utils/TextUtils'
import { PrimaryButton } from '@aok/ui-elements'
import { getSessionItem, setSessionItem } from '../../../utils/StorageUtils'
import PropTypes from 'prop-types'
import { openUrl } from '../../../utils/UrlUtils'
import { isSettingsCookieHidden } from '../../../utils/CookieUtils'

export const NEWSLETTER_HIDE_SESSION_COOKIE = 'NewsletterHideCookie'
const MOBILE_BREAKPOINT = 600

const T001 = ({ delay, checkCookie }) => {
  const [isNewsletterActive, setIsNewsletterActive] = useState(false)
  const [showNewsletter, setShowNewsletter] = useState(false)

  const isCookieAccepted = checkCookie ? isSettingsCookieHidden() : true

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!isNewsletterActive && !getSessionItem(NEWSLETTER_HIDE_SESSION_COOKIE) && isCookieAccepted) {
        setIsNewsletterActive(true)
        setShowNewsletter(true)
      }
    }, delay)

    return () => clearTimeout(timeoutId)
  }, [isNewsletterActive, delay, isCookieAccepted])

  const hideElement = () => {
    setShowNewsletter(false)

    setTimeout(() => {
      setIsNewsletterActive(false)
    }, 1000)

    setSessionItem(NEWSLETTER_HIDE_SESSION_COOKIE, true)
  }

  const navigateToNewsletterPage = () => {
    hideElement()
    openUrl('https://www.aok.de/pk/medien/newsletter/', '_blank')
  }

  const headline = {
    text: 'Immer auf dem neusten Stand – <br> %PLACEHOLDER%',
    placeholder: {
      text: 'Der AOK-Newsletter',
    },
  }

  const fadeInClass =
    typeof window !== 'undefined' && window?.innerWidth >= MOBILE_BREAKPOINT
      ? 'animate-fadeInRight'
      : 'animate-fadeInTop'
  const fadeOutClass =
    typeof window !== 'undefined' && window?.innerWidth >= MOBILE_BREAKPOINT
      ? 'animate-fadeOutRight'
      : 'animate-fadeOutTop'

  return (
    <>
      {isNewsletterActive && (
        <div
          data-tracking-name="T001"
          className={`
              600:w-528 840:w-450 bg-f8f5e3  fixed bottom-16 right-16 left-16 600:left-auto 600:bottom-24 600:right-24
              840:bottom-32 840:right-28 z-[9999] shadow-overlay rounded-8 py-32 pl-16 pr-72 600:pl-32 600:pr-80
              ${showNewsletter ? fadeInClass : fadeOutClass}
            `}
        >
          <button
            className="bg-ffffff top-16 right-16 w-48 h-48 absolute rounded-full group
            text-center shadow-blackTransparent focus-visible:outline
            focus-visible:outline-1 focus-visible:outline-18ab42 focus-visible:outline-offset-4"
            onClick={hideElement}
            type="button"
            aria-label="Newsletter schließen"
          >
            <Close
              className="
            w-16 h-16 inline fill-current text-005e3f transition ease-in-out
            duration-350 transform group-hover:scale-125
            "
            />
          </button>
          <ContextHeadline
            text={getHeadlineText(headline, 'text-18ab42')}
            className={'text-005e3f font-semibold font-buenos-aires text-24 leading-32'}
          />
          <PrimaryButton className="mt-32" onClick={navigateToNewsletterPage}>
            Newsletter abonnieren
          </PrimaryButton>
        </div>
      )}
    </>
  )
}

T001.propTypes = {
  delay: PropTypes.number,
  checkCookie: PropTypes.bool,
}

T001.defaultProps = {
  delay: 30000,
  checkCookie: true,
}

export default T001
